import React, { useEffect, useState } from "react";
import ContactForm from "../components/contact/ContactForm";
import Banner from "../components/Banner";
import { ContactInfo } from "../components/contact/ContactInfo";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed } from "../hooks/custom/useToast";
import { fetchContactDetails } from "../api/ContactApi";
import { IBannerData, IContactDetailsData } from "../exports/interfaces";
import { fetchContactBanner } from "../api/BannerApi";

const ContactPage = () => {
  const { setLoading } = useLoader();
  const [contactDetails, setContactDetails] = useState<IContactDetailsData[]>(
    [],
  );
  const [contactBanner, setContactBanner] = useState<IBannerData[]>([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    setLoading(true);
    Promise.all([fetchContactDetails(), fetchContactBanner()])
      .then(([contactDetailsData, contactBannerData]) => {
        setContactDetails(contactDetailsData);
        setContactBanner(contactBannerData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);
  return (
    <>
      <Banner title="Contact" bannerImage={contactBanner?.[0]?.image?.[0]}/>
      <ContactInfo contactDetails={contactDetails} />
      <ContactForm />
    </>
  );
};

export default ContactPage;
